import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    missingDocsTitle: {
        id: '_.dashboard.missing_docs_title',
        defaultMessage: 'Thank you for submitting your application'
    },
    missingDocsSubtitle: {
        id: '_.dashboard.missing_docs_subtitle',
        defaultMessage:
            'We’ll need some more information to come back with a decision.'
    },
    paragraph1: {
        id: '_.dashboard.missing_docs_paragraph_1',
        defaultMessage:
            'The quickest way for us to review your request is for you to link your transaction data via Open Banking under {businessInfoLink}.'
    },
    paragraph2: {
        id: '_.dashboard.missing_docs_paragraph_2',
        defaultMessage:
            'If your bank doesn’t support Open Banking, please send us your last three months’ bank statements.'
    },
    paragraph3: {
        id: '_.dashboard.missing_docs_paragraph_3',
        defaultMessage:
            'We may also need some other documents - these can be found under {businessInfoLink} or one of our team will be in touch with you.'
    },
    paragraph4: {
        id: '_.dashboard.missing_docs_paragraph_4',
        defaultMessage:
            'We’ll aim to email you with a decision within 48 hours - we’re reviewing more applications than usual at the moment, so please bear with us if we take a little longer.'
    },
    businessInfoLinkText: {
        id: '_.dashboard.missing_docs_business_info_link_text',
        defaultMessage: "'Upload Documents'"
    },
    whatIsOpenBanking: {
        id: '_.dashboard.missing_docs_what_is_open_banking_text',
        defaultMessage: 'What is Open Banking?'
    },
    helpButtonText: {
        id: '_.dashboard.missing_docs_help_button_text',
        defaultMessage: 'Need help? Contact us'
    }
});
